import { render, staticRenderFns } from "./MoneyAmountInput.vue?vue&type=template&id=4361b42c&scoped=true&"
import script from "./MoneyAmountInput.vue?vue&type=script&lang=js&"
export * from "./MoneyAmountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4361b42c",
  null
  
)

export default component.exports